import { UAParser } from 'ua-parser-js'

export const userAgent = new UAParser(navigator.userAgent)
